import { Button } from '@/components/ui/Button';
import * as Sentry from '@sentry/react';
import { RotateCw } from 'lucide-react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

/**
 * Błąd renderu strony (errorElement routera). Zamiast surowego „Unexpected
 * Application Error!” ze stosem — zwykły komunikat, odświeżenie i zgłoszenie do
 * Sentry (bez tego React Router połyka wyjątek i nikt o nim nie wie).
 */
export function RouteError() {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="mx-auto flex min-h-[50vh] max-w-md flex-col items-center justify-center gap-3 px-6 py-12 text-center">
      <h1 className="text-lg font-semibold text-fg">Coś poszło nie tak</h1>
      <p className="text-sm text-fg-muted">
        Ta strona się wysypała. Odśwież — zwykle to wystarcza. Jeśli wróci, zgłoś to w menu profilu.
      </p>
      <Button icon={RotateCw} onClick={() => window.location.reload()}>
        Odśwież
      </Button>
    </div>
  );
}
